import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { NavLink } from 'react-router-dom'
import {
  Button, Sidebar,
  Menu, Segment
} from 'semantic-ui-react'

// const NavBarZZZ = (props) => {
//   return (
//     <Header as='header'>
//       <div className="sidebar-toggle-box">
//         <div className="fa fa-bars tooltips"
//              data-placement="right"
//              data-original-title="Toggle Navigation" />
//       </div>

//       <NavLink to={"/"} className="logo"><b>SALTPAD</b></NavLink>

//       <div className="top-menu">
//         <ul className="nav pull-right top-menu">
//           <li>
//             <a className="logout" onClick={props.onLogout}>Logout</a>
//           </li>
//         </ul>
//       </div>
//     </Header>
//   )
// }

class NavBar extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = { visible: false }
    this.toggleVisibility = this.toggleVisibility.bind(this)
  }
  toggleVisibility () { this.setState({ visible: !this.state.visible }) }

  render() {
    return (
      <div style={{height: '100%'}}>
        <Menu>
          <Menu.Item icon='align justify' onClick={this.toggleVisibility}/>
          <Menu.Item><b>SALTREACT</b></Menu.Item>
          <Menu.Item position='right'>
            <Button primary content='Logout' onClick={this.props.onLogout}/>
          </Menu.Item>
        </Menu>
        <Sidebar.Pushable as={Segment} style={{height: '100%'}}>
          <Sidebar
            as={Segment}
            animation='push left'
            visible={this.state.visible}
            icon='labeled' vertical inverted
          >
            {this.props.sideContent}
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic style={{height: '100%'}}>
              {this.props.mainContent}
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    )
  }
}
NavBar.propTypes = {
  onLogout: PropTypes.func.isRequired,
  mainContent: PropTypes.element.isRequired,
  sideContent: PropTypes.element.isRequired,
}
export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar.js